export default "__VITE_ASSET__1332951a__"